import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

import { createPaginatedResultSchema } from './shared/paginated';

export const AuditTrailActionSchema = z.string();

export const AuditTrailEntityTypeSchema = z.enum([
  'agreement',
  'admin',
  'signature',
  'tier',
  'seat',
  'document',
]);

export const AuditTrailActorTypeSchema = z.enum([
  'operator',
  'admin',
  'member',
  'system',
]);

export const GroupAuditTrailItemSchema = z.object({
  id: z.number(),
  group_agreement_id: z.string().uuid(),
  actor: z.string(),
  actor_type: AuditTrailActorTypeSchema,
  action: AuditTrailActionSchema,
  entity_type: AuditTrailEntityTypeSchema,
  entity_id: z.string().uuid(),
  details: z.record(z.unknown()).optional(),
  notes: z.string().nullable().optional(),
  created_at: zodTimeStamp,
});

export const AuditTrailPaginationKeySchema = z.object({
  created_at: z.string(),
  id: z.number(),
});

export const GroupAuditTrailPaginatedResult = createPaginatedResultSchema(
  GroupAuditTrailItemSchema,
  AuditTrailPaginationKeySchema
);

export type AuditTrailAction = z.infer<typeof AuditTrailActionSchema>;
export type AuditTrailEntityType = z.infer<typeof AuditTrailEntityTypeSchema>;
export type AuditTrailActorType = z.infer<typeof AuditTrailActorTypeSchema>;
export type GroupAuditTrailItem = z.infer<typeof GroupAuditTrailItemSchema>;
export type AuditTrailPaginationKey = z.infer<
  typeof AuditTrailPaginationKeySchema
>;
export type GroupAuditTrailPaginatedResultType = z.infer<
  typeof GroupAuditTrailPaginatedResult
>;
